import { render, staticRenderFns } from "./ResumoMarketplace.vue?vue&type=template&id=0ececa78"
import script from "./ResumoMarketplace.vue?vue&type=script&lang=js"
export * from "./ResumoMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports